import { render, staticRenderFns } from "./set-design.vue?vue&type=template&id=55b32a20"
import script from "./set-design.vue?vue&type=script&lang=js"
export * from "./set-design.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports